import React from "react";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
		paddingBottom: "75px",
		paddingTop: "50px",
		paddingLeft: "30px",
		paddingRight: "30px",
	},
	header: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	textTitleDocument: {
		color: "#03989E",
		textTransform: "uppercase",
		fontSize: "24px",
		fontFamily: "Roboto bold",
	},
	textBoldUnidade: {
		fontSize: "18px",
		fontFamily: "Roboto bold",
	},
	textBoldEmpresa: {
		fontSize: "12px",
		fontFamily: "Roboto bold",
	},
	containerSubHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		marginVertical: "10px",
	},
	containerContentSubHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		width: "100%",
	},
	textBold: {
		fontSize: "12px",
		fontFamily: "Roboto bold",
		textTransform: "uppercase",
	},
	textNormal: {
		fontSize: "12px",
		textTransform: "uppercase",
	},
	contentRef: {
		marginBottom: "15px",
	},
	blocoSubHeader: {
		marginLeft: "40px",
	},
	contentQrCodeSubHeader: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	qrCode: {
		display: "block",
		marginTop: "10px",
		width: "40px",
	},
	qrCodeList: {
		width: "40px",
		height: "40px",
	},
	qrCodeListContainer: {
		width: "12.5%",
		alignItems: "center",
	},
	body: {
		marginBottom: "30px",
	},
	mainTitle: {
		backgroundColor: "#03989E",
		padding: "3px 8px",
		textTransform: "uppercase",
		color: "white",
		borderRadius: "8px",
		letterSpacing: "1px",
		fontSize: "13px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	Subtitle: {
		backgroundColor: "#E0DFDF",
		padding: "2px 8px",
		textTransform: "uppercase",
		color: "#000000",
		borderRadius: "8px",
		marginVertical: "10px",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingTop: "6px",
		fontSize: "7px",
	},
	content: {
		fontSize: "9px",
	},
	tableContent: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		textTransform: "uppercase",
		borderBottom: "2px solid #E0DFDF",
		paddingVertical: "8px",
		paddingHorizontal: "8px",
	},
	larguraTexto: {
		textAlign: "center",
		fontSize: "9px",
		width: "12.5%",
		marginBottom: "4px",
	},
	larguraTextoBold: {
		textAlign: "center",
		fontSize: "9px",
		width: "12.5%",
		marginBottom: "4px",
		fontFamily: "Roboto bold",
	},
	larguraLote: {
		width: 75,
		textAlign: "center",
		fontSize: "9px",
		marginBottom: "4px",
	},
	larguraLoteBold: {
		width: 75,
		textAlign: "center",
		fontSize: "9px",
		marginBottom: "4px",
		fontFamily: "Roboto bold",
	},
	containerTotal: {
		fontSize: "11px",
		paddingTop: "30px",
		alignItems: "flex-end",
		textTransform: "uppercase",
	},
	containerTotalCinza: {
		width: "50%",
		flexDirection: "row",
		backgroundColor: "#D9D9D9",
		paddingHorizontal: "15px",
		justifyContent: "space-between",
		padding: "7px",
		borderRadius: "8px",
	},
	observacaoContainer: {
		marginTop: "20px",
	},
	textObservacao: {
		fontSize: "10px",
	},
	footer: {
		position: "absolute",
		width: "100vw",
		height: "70px",
		bottom: 0,
		paddingHorizontal: "50px",
	},
	dividerFooter: {
		border: "1px solid #03989E",
	},
	containerFooter: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingTop: "5px",
	},
	rodapeMarca: {
		fontSize: "12px",
		fontFamily: "Roboto bold",
		color: "#03989E",
	},
	paggingContainer: {
		display: "flex",
		flexDirection: "row",
	},
	paggingText: {
		alignItems: "flex-end",
		fontSize: "10px",
		borderRight: "1px solid #03989E",
		paddingHorizontal: "5px",
		color: "#03989E",
	},
	pagnumber: { color: "#03989E", paddingHorizontal: "5px" },
});

const formatDate = (dateToFormat) => {
	if (!dateToFormat) return "-";
	const date = new Date(dateToFormat);
	return (
		("0" + date.getUTCDate()).slice(-2) +
		"/" +
		("0" + (date.getUTCMonth() + 1)).slice(-2) +
		"/" +
		date.getUTCFullYear()
	);
};

const formatMoeda = (valor) => {
	const numero = Number(valor);
	if (!isFinite(numero)) return "-";
	return numero.toLocaleString("pt-BR", {
		style: "currency",
		currency: "BRL",
	});
};

/** Produto no distribuidor não tem nome próprio: vem da cultura + variedade. */
const nomeDoProduto = (produtoFinal) => {
	const cultura = produtoFinal?.cultivo?.cultura || "";
	const variedade = produtoFinal?.cultivo?.variedade || "";
	return [cultura, variedade].filter(Boolean).join(" ") || "Não informado";
};

const descricaoDaEmbalagem = (embalagem) => {
	if (!embalagem) return "-";
	const medida = [embalagem.quantidade, embalagem.unidadeMedida?.sigla]
		.filter((parte) => parte !== null && parte !== undefined && parte !== "")
		.join("");
	return medida ? `${embalagem.descricao} (${medida})` : embalagem.descricao;
};

/**
 * Romaneio de vendas do distribuidor. Espelha o romaneio de pedidos do campo,
 * trocando pedido/lote de colheita por venda/ordem de produção.
 *
 * Os dados chegam prontos por props: quem busca é a tela, porque este documento
 * é montado duas vezes (visualizador e link de download) e buscar aqui dentro
 * dobraria as requisições.
 */
const PdfRomaneioVendas = ({ venda, usuario, idQrCodeVenda, idsQrCodeItens }) => {
	const dataEmissao = new Date().toLocaleDateString("pt-BR");
	const horaEmissao = new Date().toLocaleTimeString("pt-BR");

	if (!venda) return <Document />;

	// O canvas do QR Code está escondido na tela; aqui ele vira imagem.
	const imagemDoQrCode = (elementId) => {
		const canvas = elementId ? document.getElementById(elementId) : null;
		return canvas ? canvas.toDataURL() : null;
	};

	const qrCodeVenda = imagemDoQrCode(idQrCodeVenda);
	const itens = venda.itens ?? [];

	const totalDaVenda = itens.reduce(
		(soma, item) => soma + Number(item.preco ?? 0) * Number(item.quantidade ?? 0),
		0,
	);

	return (
		<Document>
			<Page size="A4" orientation="landscape" style={styles.page}>
				<View style={styles.header} fixed>
					<View>
						<Text>Romaneio de</Text>
						<Text style={styles.textTitleDocument}>Vendas</Text>
						<Text style={styles.textBoldUnidade}>
							{venda.unidadeDistribuidora?.nome ?? "Não informado"}
						</Text>
						{venda.unidadeDistribuidora?.nomeFantasia && (
							<Text style={styles.textBoldEmpresa}>
								{venda.unidadeDistribuidora.nomeFantasia}
							</Text>
						)}
					</View>
				</View>

				<View style={styles.containerSubHeader}>
					<View style={styles.containerContentSubHeader}>
						<View>
							<View style={styles.contentRef}>
								<Text style={styles.textBold}>Número da venda:</Text>
								<Text style={styles.textNormal}>{venda.numeroVenda ?? "-"}</Text>
							</View>
							<View>
								<Text style={styles.textBold}>Cliente:</Text>
								<Text style={styles.textNormal}>
									{venda.cliente?.nome ?? "Não informado"}
								</Text>
							</View>
						</View>

						<View style={styles.blocoSubHeader}>
							<View style={styles.contentRef}>
								<Text style={styles.textBold}>Data da expedição</Text>
								<Text style={styles.textNormal}>
									{formatDate(venda.dataExpedicao)}
								</Text>
							</View>
							<View>
								<Text style={styles.textBold}>Nota fiscal</Text>
								<Text style={styles.textNormal}>{venda.notaFiscal || "-"}</Text>
							</View>
						</View>

						<View style={styles.contentQrCodeSubHeader}>
							<Text style={styles.textBold}>qrcode da venda</Text>
							{qrCodeVenda && <Image src={qrCodeVenda} style={styles.qrCode} />}
						</View>
					</View>
				</View>

				<View style={styles.body}>
					<View style={styles.mainTitle}>
						<Text>Itens da venda</Text>
					</View>

					<View style={styles.content}>
						<View style={styles.Subtitle}>
							<Text style={styles.larguraTextoBold}>qrcode</Text>
							<Text style={styles.larguraTextoBold}>produto</Text>
							<Text style={styles.larguraLoteBold}>lote</Text>
							<Text style={styles.larguraTextoBold}>embalagem</Text>
							<Text style={styles.larguraTextoBold}>volumes</Text>
							<Text style={styles.larguraTextoBold}>quantidade</Text>
							<Text style={styles.larguraTextoBold}>preço unit.</Text>
							<Text style={styles.larguraTextoBold}>preço total</Text>
						</View>

						{itens.map((item) => {
							const ordemProducao = item.ordemProducao;
							const qrCodeItem = imagemDoQrCode(idsQrCodeItens?.[item.id]);

							return (
								<View key={item.id} style={styles.tableContent} wrap={false}>
									<View style={styles.qrCodeListContainer}>
										{qrCodeItem && (
											<Image src={qrCodeItem} style={styles.qrCodeList} />
										)}
									</View>
									<Text style={styles.larguraTexto}>
										{nomeDoProduto(ordemProducao?.produtoFinal)}
									</Text>
									<Text style={styles.larguraLote}>
										{ordemProducao?.loteRastreabilidade ||
											(ordemProducao?.numeroOP
												? `OP ${ordemProducao.numeroOP}`
												: "-")}
									</Text>
									<Text style={styles.larguraTexto}>
										{descricaoDaEmbalagem(ordemProducao?.embalagemProdutoFinal)}
									</Text>
									<Text style={styles.larguraTexto}>{item.volumes ?? "-"}</Text>
									<Text style={styles.larguraTexto}>{item.quantidade ?? "-"}</Text>
									<Text style={styles.larguraTexto}>
										{formatMoeda(item.preco)}
									</Text>
									<Text style={styles.larguraTexto}>
										{formatMoeda(
											Number(item.preco ?? 0) * Number(item.quantidade ?? 0),
										)}
									</Text>
								</View>
							);
						})}
					</View>

					<View style={styles.containerTotal}>
						<View style={styles.containerTotalCinza}>
							<Text>Total da venda</Text>
							<Text>{formatMoeda(totalDaVenda)}</Text>
						</View>
					</View>

					{venda.observacao ? (
						<View style={styles.observacaoContainer}>
							<Text style={styles.textBold}>Observação</Text>
							<Text style={styles.textObservacao}>{venda.observacao}</Text>
						</View>
					) : null}
				</View>

				<View style={styles.footer} fixed>
					<View style={styles.dividerFooter}></View>
					<View style={styles.containerFooter}>
						<Text style={styles.rodapeMarca}>Sisagri</Text>
						<View style={styles.paggingContainer}>
							<View style={styles.paggingText}>
								<Text style={{ fontFamily: "Roboto bold" }}>
									https://sisagri.com.br/
								</Text>
								<Text>
									{dataEmissao +
										" - " +
										horaEmissao +
										" - " +
										(usuario?.name ?? usuario?.nome ?? "Não informado")}
								</Text>
							</View>
							<Text
								style={styles.pagnumber}
								render={({ pageNumber }) => `${pageNumber}`}
							/>
						</View>
					</View>
				</View>
			</Page>
		</Document>
	);
};

export default PdfRomaneioVendas;
